import React from 'react';
import { componentMap } from './compMapping';

export default function Card(props) {
  const { details, setValues = () => {} } = props;
  return (
    <div
      css={`
        background: ${details?.bg_color};
        padding: ${details?.padding || '1rem'};
        border-radius: ${details?.border_radius || '5px'};
        display: flex;
        flex-direction: ${details?.orientation === 'vertical'
          ? 'column'
          : 'row'};
        gap: ${details?.gap || '0.5rem'};
        width: ${details?.width || '100%'};
      `}
    >
      {details?.children.length > 0 &&
        details?.children.map((child) => {
          let CompName = '';
          if (child.type in componentMap)
            CompName = componentMap[`${child.type}`];
          else return null;
          return (
            <CompName
              details={child}
              setValues={setValues}
              inputKey={child?.id}
            />
          );
        })}
    </div>
  );
}
